import React, { MouseEventHandler, ReactNode } from 'react';
import { mui } from '~/tools/mui';

type IconProps = {
  ariaLabel?: string;
  handleOnClick?: MouseEventHandler;
  tooltip: string;
  children?: ReactNode;
  className?: string;
  disableFocusListener?: boolean;
  enterDelay?: boolean;
  enterTouchDelay?: number;
  id?: string;
  interactive?: boolean;
  leaveDelay?: number;
  leaveTouchDelay?: number;
  onClose?: () => void;
  open?: boolean;
  placement?: string;
  PopperProps?: Object;
  TransitionComponent?: ReactNode;
  TransitionProps?: Object;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  testId?: string;
};

export function IconButton({ children, disabled, handleOnClick, ariaLabel, tooltip, testId, ...other }: IconProps) {
  return disabled ? (
    <mui.IconButton
      size="large"
      disabled={disabled}
      onClick={handleOnClick}
      aria-label={ariaLabel}
      data-testid={testId}
      {...other}
    >
      {children}
    </mui.IconButton>
  ) : (
    <mui.Tooltip title={tooltip} disableInteractive>
      <mui.IconButton size="large" onClick={handleOnClick} data-testid={testId} aria-label={ariaLabel} {...other}>
        {children}
      </mui.IconButton>
    </mui.Tooltip>
  );
}

export default IconButton;
